module.exports = __webpack_public_path__ + "media/images/vector-31@2x-3b709a9569985622a0cee13630d40a82.png";